// extracted by mini-css-extract-plugin
export default {"component":"b29WT_","wrapper":"c29WT_","badge":"d29WT_"};